import { autoinject, bindable } from 'aurelia-framework';
import { TabService } from './tab-service';

@autoinject
export class TabButton {
	tabViewId: string;
	@bindable tabId: string;
	@bindable labelResource: string;
	@bindable click: (params: any) => void;

	constructor(private tabService: TabService) {
	}

	attached() {
		if (!this.tabService.anySelected(this.tabViewId, this.tabId)) {
			this.tabService.select(this.tabViewId, this.tabId);
		}
	}

	get isActive(): boolean {
		return this.tabService.isActive(this.tabViewId, this.tabId);
	}

	select() {
		this.tabService.select(this.tabViewId, this.tabId);
		if (this.click != null) { this.click({ tabId: this.tabId }); }
	}

	handleKeypress(e: KeyboardEvent) {
		e.stopPropagation();

		if (e.code === "Space" || e.code === "Enter") {
			this.select();
		}
	}
}
